<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="TOC">CONTENTS</h1>
<p class="toc" id="pro"><a href="#/7prologue#prologue"><b>Prologue</b></a></p>
<p class="toc" id="theb"><a href="#/8thebutterfly#thebutterfly"><b>The Butterfly Effect</b></a></p>
<p class="toc1">Edward Lorenz and his toy weather. The computer misbehaves. Long-range forecasting is doomed. Order masquerading as randomness. A world of nonlinearity. “We completely missed the point.”</p>
<p class="toc" id="rev"><a href="#/10revolution#revolution"><b>Revolution</b></a></p>
<p class="toc1">A revolution in seeing. Pendulum clocks, space balls, and playground swings. The invention of the horseshoe. A mystery solved: Jupiter’s Great Red Spot.</p>
<p class="toc" id="life"><a href="#/12lifeupdown#lifeupdown"><b>Life’s Ups and Downs</b></a></p>
<p class="toc1">Modeling wildlife populations. Nonlinear science, “the study of non-elephant animals.” Pitchfork bifurcations and a ride on the Spree. A movie of chaos and a messianic appeal.</p>
<p class="toc" id="ageo"><a href="#/14ageometry#ageometry"><b>A Geometry of Nature</b></a></p>
<p class="toc1">A discovery about cotton prices. A refugee from Bourbaki. Transmission errors and jagged shores. New dimensions. The monsters of fractal geometry. Quakes in the schizosphere. From clouds to blood vessels. The trash cans of science. “To see the world in a grain of sand.”</p>
<p class="toc" id="str"><a href="#/16strange#strange"><b>Strange Attractors</b></a></p>
<p class="toc1">A problem for God. Transitions in the laboratory. Rotating cylinders and a turning point. David Ruelle’s idea for turbulence. Loops in phase space. Mille-feuilles and sausage. An astronomer’s mapping. “Fireworks or galaxies.”</p>
<p class="toc" id="uni"><a href="#/18universality#universality"><b>Universality</b></a></p>
<p class="toc1">A new start at Los Alamos. The renormalization group. Decoding color. The rise of numerical experimentation. Mitchell Feigenbaum’s breakthrough. A universal theory. The rejection letters. Meeting in Como. Clouds and paintings.</p>
<p class="toc" id="theex"><a href="#/20theexperiment#theexperiment"><b>The Experimenter</b></a></p>
<p class="toc1">Helium in a Small Box. “Insolid billowing of the solid.” Flow and form in nature. Albert Libchaber’s delicate triumph. Experiment joins theory. From one dimension to many.</p>
<p class="toc" id="imag"><a href="#/22images#images"><b>Images of Chaos</b></a></p>
<p class="toc1">The complex plane. Surprise in Newton’s method. The Mandelbrot set: sprouts and tendrils. Art and commerce meet science. Fractal basin boundaries. The chaos game.</p>
<p class="toc" id="thedy"><a href="#/24thedynamical#thedynamical"><b>The Dynamical Systems Collective</b></a></p>
<p class="toc1">Santa Cruz and the sixties. The analog computer. Was this science? “A long-range vision.” Measuring unpredictability. Information theory. From microscale to macroscale. The dripping faucet. Audiovisual aids. An era ends.</p>
<p class="toc" id="inner"><a href="#/26innerrhythms#innerrhythms"><b>Inner Rhythms</b></a></p>
<p class="toc1">A misunderstanding about models. The complex body. The dynamical heart. Resetting the biological clock. Fatal arrhythmia. Chick embryos and abnormal beats. Chaos as health.</p>
<p class="toc" id="cha"><a href="#/28chaos#chaos"><b>Chaos and Beyond</b></a></p>
<p class="toc1">New beliefs, new definitions. The Second Law, the snowflake puzzle, and loaded dice. Opportunity and necessity.</p>
<p class="toc" id="after"><a href="#/30afterword#afterword"><b>Afterword</b></a></p>
<p class="toc" id="note"><a href="#/31notes#notes"><b>Notes on Sources and Further Reading</b></a></p>
<p class="toc" id="ack"><a href="#/32acknowledgments#acknowledgments"><b>Acknowledgments</b></a></p>
<p class="toc" id="ind"><a href="#/33index#index"><b>Index</b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-TOC.vue?965b198e